export default __webpack_public_path__ + "images/377efcadd26253fb9bcb57f8786f7e54-5_mobile_659x494.jpg";